import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'

import ButtonChangeText from '../ButtonChangeText'

import { adsSelector, adsWasLoadedSelector } from '../../../../modules/selectors/ads'
import { campaignSelector } from '../../../../modules/selectors/campaigns'
import {
  lineItemsSelector,
  lineItemSelector,
  lineItemWasLoadedSelector,
  lineItemsWasLoadedSelector
} from '../../../../modules/selectors/lineItems'

import useStyles from './styles'
import { getSelectedPlatform } from '../../../../helpers/handlePlatformSelection'
import { formatTextByPlatform } from './helpers'

const AdCopyPreviewsButton = () => {
  const classes = useStyles()

  const ads = useSelector(adsSelector)
  const adsWasLoaded = useSelector(adsWasLoadedSelector)
  const campaign = useSelector(campaignSelector)
  const lineItems = useSelector(lineItemsSelector)
  const lineItem = useSelector(lineItemSelector)

  const lineItemWasLoaded = useSelector(lineItemWasLoadedSelector)
  const lineItemsWasLoaded = useSelector(lineItemsWasLoadedSelector)

  const selectedPlatform = getSelectedPlatform()

  const copyPreviewsHandler = useCallback(() => {
    if (!campaign || !ads) {
      console.warn('Missing campaign or ads data.')
      return
    }

    const textToCopy = formatTextByPlatform({
      ads,
      campaign,
      lineItems,
      lineItem,
      lineItemWasLoaded,
      lineItemsWasLoaded,
      selectedPlatform
    })

    // Copy the text to the clipboard
    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        console.log('Copied to clipboard:', textToCopy)
      })
      .catch(err => {
        console.error('Failed to copy text:', err)
      })
  }, [ads, campaign, lineItems, lineItem, lineItemWasLoaded, lineItemsWasLoaded, selectedPlatform])

  // Disable button if either no line items are loaded or no ads are loaded
  const isButtonDisabled = !(lineItemWasLoaded || lineItemsWasLoaded) || !adsWasLoaded

  return (
    <ButtonChangeText
      className={classes.copyPreviewsBtn}
      onClick={copyPreviewsHandler}
      textToChange={'Copied!'}
      disabled={isButtonDisabled}
    >
      Copy previews
    </ButtonChangeText>
  )
}

export default AdCopyPreviewsButton
